<template>
    <v-container fluid>
        <v-row>
            <v-col
                cols="12"
            >
                <v-alert
                    color="light-blue darken-4"
                    dark
                    icon="mdi-file-document-edit-outline"
                    border="top"
                    prominent
                >
                    <v-row align="center">
                        <v-col class="grow text-h4">Business Claims</v-col>
                    </v-row>
                </v-alert>
            </v-col>

            <v-col
                cols="12"
            >
                <v-alert
                    color="orange darken-2"
                    colored-border
                    icon="mdi-alert-outline"
                    border="top"
                    prominent
                    elevation="6"
                >
                    To Renew/Retire this Business for the first time, you must file a claim with the BPLO office that you are authorized to conduct transactions for and by this business and its owners. Press Claim and upload a proof of authority such as previous business permit applications/permits, proof of business ownership, authorization letter from the business owner/corporation, power of attorney, or similar.
                </v-alert>
            </v-col>

            <v-col
                cols="12"
            >
                <v-btn
                    text
                    @click="AddNew"
                >
                    <v-icon class="mr-2">mdi-plus</v-icon>New Claim
                </v-btn>
            </v-col>

            <v-col
                cols="12"
            >
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :options.sync="options"
                        :server-items-length="total"
                        :loading="loading"
                        class="elevation-6"
                        fixed-header
                    >
                        <template v-slot:item.message="{ item }">
                            <div style="width: 200px;" class="text-left" v-html="nl2br(item.message)"></div>
                        </template>

                        <template v-slot:item.status="{ item }">
                            {{ Status(item.status) }}
                        </template>

                        <template v-slot:item.files="{ item }">
                            <template v-for="(file, i) in item.files">
                                <v-chip
                                    :key="`supp-doc-${i}`"
                                    v-if="FileExtension(file) == 'pdf'"
                                    color="green darken-2"
                                    dark
                                    class="mt-1 mr-1 d-inline-block"
                                    :close="parseInt(item.status) == 0"
                                    @click:close="RemoveFile(item, file, i)"
                                    @click="PDFViewer(file)"
                                >
                                    Document #{{ i + 1 }} ({{FileExtension(file).toUpperCase()}})
                                </v-chip>
                                <v-chip
                                    :key="`supp-doc-${i}`"
                                    v-else
                                    color="red darken-2"
                                    dark
                                    class="mt-1 mr-1 d-inline-block"
                                    @click="ViewProfilePhoto(file)"
                                    :close="parseInt(item.status) == 0"
                                    @click:close="RemoveFile(item, file, i)"
                                >
                                    Document #{{ i + 1 }} ({{FileExtension(file).toUpperCase()}})
                                </v-chip>
                            </template>
                        </template>

                        <template v-slot:item.dateadded="{ item }">
                            <div v-html="MomentDate(item.dateadded)" class="text-no-wrap"></div>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <div class="text-no-wrap">
                                <v-btn
                                    v-if="parseInt(item.status) == 0"
                                    text
                                    small
                                    color="blue darken-2"
                                    @click="Edit(item)"
                                >
                                    <v-icon>mdi-lead-pencil</v-icon>
                                </v-btn>

                                <v-btn
                                    v-if="[0, 1].includes(parseInt(item.status))"
                                    text
                                    small
                                    color="red darken-2"
                                    @click="Delete(item)"
                                >
                                    <v-icon>mdi-close-circle-outline</v-icon>
                                </v-btn>
                            </div>
                        </template>
                        
                        <template v-slot:item.plateno="{ item }">
                            {{ item.link }}
                        </template>
                    </v-data-table>
                </v-card>

                <v-btn
                    text
                    @click="getDataFromApiSync"
                >
                    <v-icon class="mr-2">mdi-refresh</v-icon>Refresh List
                </v-btn>
            </v-col>
        </v-row>

        <v-dialog
            v-model="claimform"
            scrollable
            max-width="800"
            overlay-opacity="0.2"
            persistent
        >
            <v-card>
                <v-card-title class="headline deep-orange darken-1 white--text"><i class="mdi mdi-file-document-edit-outline mr-2"></i>Claim Form</v-card-title>

                <v-card-text
                    class="mt-6 mb-6"
                >
                    <v-row dense>
                        <v-col
                            cols="12"
                        >
                            <!-- <v-textarea
                                v-model="claim.message"
                                label="Claim Message"
                                outlined
                                height="100"
                            ></v-textarea> -->

                            <v-select
                                v-model="claim.message"
                                label="Reason for Claim"
                                outlined
                                :items="claimreasons"
                                item-text="text"
                                item-value="value"
                                dense
                            ></v-select>
                        </v-col>

                        <v-col
                            cols="12"
                        >
                            <v-file-input
                                label="Supporting Documents"
                                outlined
                                dense
                                show-size accept="image/jpeg, image/png, application/pdf"
                                @change="FileAttachment"
                                v-model="attachments"
                                prepend-inner-icon="mdi-file-find-outline"
                                multiple
                                chips
                                small-chips
                                counter
                                hint="You can attach one or more file/s. Only JPEG, PNG and PDF files are allowed"
                                persistent-hint
                            ></v-file-input>
                        </v-col>

                        <v-col
                            cols="12"
                            v-if="claim._id.toString().length == 0"
                        >
                            <v-text-field
                                v-model="claim.link"
                                type="number"
                                label="Plate Number"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions
                    class="deep-orange darken-1"
                >
                    <v-spacer></v-spacer>

                    <v-btn
                        dark
                        color="red darker-4"
                        @click="claimform = false"
                    >
                        Close
                    </v-btn>

                    <v-btn
                        dark
                        color="green darker-4"
                        @click="SaveChanges"
                        :disabled="((claim.link.toString().length > 0 && claim.files.length > 0 && claim.message.toString().length > 0 && claim._id.toString().length == 0)|| (claim.link.toString().length > 0 && claim.message.toString().length > 0 && claim._id.toString().length > 0)) == false"
                    >
                        Submit Claim
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <LightBox
            ref="lightbox"
            :media="lightboxmedia"
            :show-caption="false"
            :show-light-box="false"
        />

        <v-dialog
            v-model="pdf.show"
            scrollable
            max-width="1080"
            overlay-opacity="0.2"
            persistent
            style="z-index: 9999;"
        >
            <v-card>
                <v-card-title class="headline deep-orange darken-1 white--text"><i class="mdi mdi-file-pdf-outline mr-2"></i>PDF Viewer</v-card-title>

                <v-card-text
                    id="pdfcard"
                >
                    <v-card-actions class="justify-center">
                        <v-btn
                            class="mr-2"
                            text
                            :disabled="pdf.page == 1"
                            @click="pdf.page = 1"
                        >
                            First
                        </v-btn>
                        <v-btn
                            class="mr-2"
                            text
                            :disabled="pdf.page == 1"
                            @click="pdf.page--"
                        >
                            Prev
                        </v-btn>
                        Page <input v-model.number="pdf.page" type="number" style="width: 3.5em" class="mx-2 text-center" /> of {{ pdf.pageCount }}
                        <v-btn
                            class="ml-2"
                            text
                            :disabled="pdf.page == pdf.pageCount"
                            @click="pdf.page++"
                        >
                            Next
                        </v-btn>
                        <v-btn
                            class="ml-2"
                            text
                            :disabled="pdf.page == pdf.pageCount"
                            @click="pdf.page = pdf.pageCount"
                        >
                            Last
                        </v-btn>
                    </v-card-actions>

                    <PDF
                        ref="pdfviewer"
                        v-if="pdf.show"
                        :src="pdf.media"
                        @num-pages="pdf.pageCount = $event"
                        :page="pdf.page"
                        @page-loaded="PDFLoaded($event)"
                    ></PDF>
                </v-card-text>

                <v-card-actions
                    class="deep-orange darken-1"
                >
                    <v-spacer></v-spacer>

                    <v-btn 
                        text
                        dark
                        @click="pdf.show = false"
                    >Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import _ from "lodash"
import axios from "axios"
import moment from "moment"
import LightBox from 'vue-image-lightbox'
import PDF from 'vue-pdf'

export default {
    name: 'tdnclaims',
    props: ['CheckIfLoggedInInternal'],
    metaInfo: {
        title: 'Digital Tuguegarao - Tax Declaration Number Claims'
    },
    components: {
        LightBox,
        PDF,
    },
    data() {
        return {
            pdfloaded: false,
            pdf: {
                show: false,
                media: [],
                currentPage: 0,
                pageCount: 0,
                page: 1,
            },
            CRM_Interval: null,
            attachments: undefined,
            claim: {
                _id: '',
                type: 'business',
                division: 'BPLO',
                message: '',
                link: '',
                files: [],
            },
            claimform: false,
            loadingsearch: false,
            search: null,
            entries: [],
            searchcancel: null,
            citizen: {},
            // list
            loading: false,
            items: [],
            total: 0,
            headers: [
                {
                    text: 'Plate Number',
                    sortable: false,
                    value: 'plateno',
                    align: 'center',
                },
                {
                    text: 'Message',
                    sortable: false,
                    value: 'message',
                    align: 'center',
                },
                {
                    text: 'Supporting Document/s',
                    sortable: false,
                    value: 'files',
                    align: 'center',
                },
                {
                    text: 'Status',
                    sortable: false,
                    value: 'status',
                    align: 'center',
                },
                {
                    text: 'Date Added',
                    sortable: false,
                    value: 'dateadded',
                    align: 'center',
                },
                {
                    text: 'Actions',
                    sortable: false,
                    value: 'actions',
                    align: 'center',
                },
            ],
            options: {},
            employeeajax: null,
            lightboxmedia: [],
            claimreasons: [],
            claimreasonscache: [],
        }
    },
    computed: {
        itemslink() {
            return this.entries.map(x => {
                let tdnformatted = x.TDN_IntKey.toString()

                const possiblesuffix = _.padStart(x.DeclarationNo.toString(), 5, '0')
                // const remaining = x.ARPNo.toString()
                // let possibleprefix = _.padStart(x.ARPNo.toString().replace(possiblesuffix, ''), 2, '0')
                // let possibleprefix = _.padStart(_.trimEnd(x.ARPNo.toString(), x.DeclarationNo.toString()), 2, '0')
                const possibleprefix = _.padStart(x.ARPNo.toString().substr(0, x.ARPNo.toString().length - x.DeclarationNo.toString().length), 2, '0')

                // if(x.ARPNo.toString().replace(possiblesuffix, '').toString().length > 2){
                //     possibleprefix = _.padStart(_.trimEnd(x.ARPNo.toString(), x.DeclarationNo.toString()), 2, '0')
                // }

                // console.log(`${x.ARPNo.toString()} ${possiblesuffix} ${possibleprefix}`)
                if(possiblesuffix.toString().length > 0 && possibleprefix.toString().length > 0){
                    tdnformatted = `${possibleprefix}-${possiblesuffix}`

                    if(x.tdnsuffix.toString().length > 0){
                        tdnformatted = `${tdnformatted}-${x.tdnsuffix}`
                    }
                }

                const displaynameaddress = x.DisplayNameAddress.toString().split(';')
                const displayname = _.trim(displaynameaddress[0])
                const displayaddress = _.trim(displaynameaddress[1])

                return Object.assign({}, x, { tdnformatted, displayname, displayaddress })
            })
        }
    },
    watch: {
        options: {
            handler () {
                this.getDataFromApi()
                    .then(data => {
                        this.items = data.items
                        this.total = parseInt(data.total)
                    })
            },
            deep: true,
        },
        search () {
            // Items have already been loaded
            // if (this.acitems.length > 0) return

            if(this.searchcancel){
                this.searchcancel.cancel()
                this.loadingsearch = false
            }

            // Items have already been requested
            if (this.loadingsearch) return

            if (!this.search) return

            if (this.search.toString().length == 0) return

            this.loadingsearch = true

            this.searchcancel = axios.CancelToken.source()

            axios({
                method: 'post',
                url: `${this.domain}/op_rpt_search_tdn`,
                data: {
                    search: this.search.toString(),
                }
            })
                .then(response => {
                    this.loadingsearch = false

                    const entries = this.$jwt.decode(response.data.items, this.jwtsecret)

                    this.entries = entries.items

                    // console.log(this.entries)
                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => (this.loadingsearch = false))
        },
    },
    methods: {
        Delete(item) {
            this.$emit('ol', true)

            axios({
                method: 'post',
                url: `${this.domain}/crm_claim_remove`,
                data: {
                    _id: item._id,
                    uid: this.citizen._id.toString(),
                }
            })
                .then(response => {
                    this.$emit('ol', false)

                    if(response.data.response){
                        this.$emit('snackbar', {
                            variant: 'success',
                            message: 'Claim has been cancelled',
                        })

                        this.getDataFromApiSync()
                    } else{
                        this.$emit('snackbar', {
                            variant: 'warning',
                            message: response.data.message.toString(),
                        })
                    }
                })
                .catch(() => {
                    this.$emit('ol', false)

                    this.$emit('snackbar', {
                        variant: 'error',
                        message: 'Something went wrong... Try again...'
                    })
                })
        },
        Edit(item) {
            this.Reset()

            this.claim = {
                _id: item._id.toString(),
                type: 'business',
                division: 'BPLO',
                message: item.message.toString(),
                link: item.link.toString(),
                files: [],
            }

            this.claimform = true

            const filtered = this.claimreasons.filter(x => {
                return x.value.toString() == item.message.toString()
            })

            if(filtered.length == 0){
                this.claimreasons.push({
                    text: item.message.toString(),
                    value: item.message.toString(),
                })
            }
        },
        PDFViewer(file) {
            this.pdf.media = `${this.domain}/${file.replace('public/files', 'serve/staticfiles')}`
            this.pdf.show = true
            this.pdf.page = 1
        },
        PDFLoaded(event) {
            this.pdf.currentPage = event

            this.pdfloaded = true
        },
        RemoveFile(item, file, index) {
            this.$emit('ol', true)

            axios({
                method: 'post',
                url: `${this.domain}/crm_claim_file_remove`,
                data: {
                    _id: item._id,
                    file,
                    uid: this.citizen._id.toString(),
                }
            })
                .then(response => {
                    this.$emit('ol', false)

                    if(response.data.response){
                        this.$emit('snackbar', {
                            variant: 'success',
                            message: 'File has been deleted',
                        })

                        // this.getDataFromApiSync()
                        item.files.splice(index, 1)
                    } else{
                        this.$emit('snackbar', {
                            variant: 'warning',
                            message: response.data.message.toString(),
                        })
                    }
                })
                .catch(() => {
                    this.$emit('ol', false)

                    this.$emit('snackbar', {
                        variant: 'error',
                        message: 'Something went wrong... Try again...'
                    })
                })
        },
        FileExtension(file) {
            return file.split('.').pop()
        },
        ViewProfilePhoto(img) {
            const _img = `${this.domain}/serve/staticfiles/${img.replace('public/files/', '')}`

            this.lightboxmedia = [{
                thumb: _img,
                src: _img,
            }]

            this.$refs.lightbox.showImage(0)
        },
        MomentDate(dt) {
            return moment(parseInt(dt) * 1000).format('MMM D, YYYY h:mm A')
        },
        Status(status) {
            let stat = 'Pending'

            switch(parseInt(status)) {
                case 1:
                    stat = 'Approved'
                    break;
                case 2:
                    stat = 'Disapproved'
                    break;
                case 3:
                    stat = 'Cancelled'
                    break;
            }

            return stat
        },
        FilesAttachmentsHtml(files) {
            return files.map(x => {
                x = x.split('/').pop()

                return x
            }).join('<br />')
        },
        nl2br (str, is_xhtml) {   
            var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';    
            return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1'+ breakTag +'$2');
        },
        Reset() {
            this.attachments = undefined

            this.claim = {
                _id: '',
                type: 'business',
                division: 'BPLO',
                message: '',
                link: '',
                files: [],
            }

            this.claimreasons = _.cloneDeep(this.claimreasonscache).map(x => {
                return {
                    text: x.reason.reason.toString(),
                    value: x.reason.reason.toString(),
                }
            })
        },
        AddNew() {
            this.Reset()

            this.claimform = true
        },
        async FileAttachment(files) {
            if(files.length == 0){
                this.attachments = undefined
            }

            this.claim.files = []

            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = (e) => resolve(e.target.result)
                reader.onerror = error => reject(error)
            })

            for await (const file of files) {
                toBase64(file).then(mfile => {
                    this.claim.files.push(mfile)
                }).catch(() => {
                    
                })
            }
        },
        SaveChanges() {
            if(this.claim.files.length > 0 && this.claim.message.toString().length > 0 && this.claim.link.toString().length > 0){
                this.$emit('ol', true)

                let claimdata = _.cloneDeep(this.claim)
                claimdata.uid = this.citizen._id.toString()

                axios({
                    method: 'post',
                    url: `${this.domain}/crm_claims_process`,
                    data: claimdata
                })
                    .then(response => {
                        this.$emit('ol', false)

                        if(response.data.response){
                            this.claimform = false

                            this.$emit('snackbar', {
                                variant: 'success',
                                message: 'Your claim has been submitted to the BPLO. Please wait for a Text or Email message once your claim has been approved and you can proceed with your application.',
                            })

                            this.getDataFromApiSync()
                        } else{
                            this.$emit('snackbar', {
                                variant: 'warning',
                                message: response.data.message.toString(),
                            })
                        }
                    })
                    .catch(() => {
                        this.$emit('ol', false)

                        this.$emit('snackbar', {
                            variant: 'error',
                            message: 'Something went wrong... Try again...'
                        })
                    })
            }
        },
        getDataFromApiSync() {
            this.getDataFromApi()
                .then(data => {
                    this.items = data.items
                    this.total = parseInt(data.total)
                })
        },
        getDataFromApi() {
            this.loading = true

            return new Promise((resolve) => {
                const { page, itemsPerPage } = this.options
                const start_row = (parseInt(page) - 1) * parseInt(itemsPerPage)

                if(this.employeeajax){
                    this.employeeajax.cancel()
                }

                this.employeeajax = axios.CancelToken.source()

                axios({
                    url: `${this.domain}/crm_claims_list`,
                    method: 'POST',
                    data: {
                        start_row,
                        limit: itemsPerPage,
                        uid: this.citizen._id.toString(),
                        type: this.claim.type.toString(),
                        division: this.claim.division.toString(),
                    },
                    cancelToken: this.employeeajax.token
                })
                    .then(response => {
                        this.loading = false

                        if(response.data.response){
                            setTimeout(() => {
                                const items = this.$jwt.decode(response.data.items, this.jwtsecret)

                                // console.log(items.items)

                                resolve({
                                    items: items.items,
                                    total: response.data.total
                                })
                            }, 500)
                        } else{
                            setTimeout(() => {
                                resolve({
                                    items: [],
                                    total: 0
                                })
                            }, 500)
                        }
                    }).catch(function(err) {
                        console.log(err)

                        resolve({
                            items: [],
                            total: 0
                        })
                    })
            })
        },
        ClaimReasons() {
            axios({
                method: 'post',
                url: `${this.domain}/crm_claim_reasons`,
                data: {
                    type: this.claim.type.toString(),
                    division: this.claim.division.toString(),
                }
            })
                .then(response => {
                    if(response.data.response){
                        const reasons = this.$jwt.decode(response.data.reasons, this.jwtsecret)

                        if(reasons.reasons.length > 0){
                            this.claimreasonscache = _.cloneDeep(reasons.reasons)
                        }
                    }
                })
        }
    },
    mounted() {
        this.CheckIfLoggedInInternal()

        const { user } = this.$jwt.decode(this.$session.get('crmusersessionsignature'), this.jwtsecret)
        user.mobile = user.mobile || ''
        delete user.passwd
        delete user.signature

        this.citizen = _.cloneDeep(user)

        // check
        this.CRM_Interval = setInterval(() => {
            if(!(this.$ls.get('isLoggedIn') && this.$session.exists() && this.$session.get('crmusersessionsignature'))){
                clearInterval(this.CRM_Interval)

                this.$router.push({
                    name: 'login'
                }).catch(()=>{})
            }
        }, 500)

        this.ClaimReasons()
    }
}
</script>